export type DashboardsState = {
    working: {
        [statKey: string]: boolean
    }
    stats: {
        [statKey: string]: any
    }
}

const initialState: DashboardsState = {
    working: {},
    stats: {},
}

export default initialState
